"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverCenterHorizontal(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.leftUpAnchor.x + trigger.width / 2 - content.width / 2;
    var top = trigger.leftUpAnchor.y + trigger.height / 2 - content.height / 2;
    if (left < 0 || left + content.width > viewport.width) {
        return false;
    }
    if (top < 0) {
        return {
            left: left,
            top: 0,
        };
    }
    if (top + content.height > viewport.height && viewport.height - content.height >= 0) {
        return {
            left: left,
            top: viewport.height - content.height,
        };
    }
    return false;
}
exports.default = resolverCenterHorizontal;
//# sourceMappingURL=resolverCenterHorizontal.js.map